export default __webpack_public_path__ + "static/media/IMG_8234.7c243bef.jpeg";